export function renderQuality(viewport,devicePixelRatio,{singleToy=false}={}){
 const detailed=singleToy||viewport.mode==='desktop',pixels=detailed?3000000:1500000;
 return {
  pixelRatio:Math.min(detailed?Math.max(1.25,devicePixelRatio):devicePixelRatio,detailed?2:1.5,Math.sqrt(pixels/(viewport.width*viewport.height))),
  transmissionScale:detailed?1:.5,
  shadowSize:detailed?1024:512,
  simplifyToy:!detailed,
 };
}
